<template>
  <div>
    <!-- Authors Table -->
    <a-row :gutter="24" type="flex">
      <!-- Authors Table Column -->
      <a-col :span="24" class="mb-24">
        <!-- Authors Table Card -->
        <AlumniTable :optionNationality="optionNationality" :optionProgram="optionProgram"
          :optionJobselect="optionJobselect" :optionMajor="optionMajor" :optionCountry="optionCountry" :loading="loading"
          :data="tableData" :columns="tableColumns" :currentPage="currentPage" :countObjData="countObjData"
          :perPage="perPage" :optionYear="optionYear" @changepage="onChangePage" @search="onSearch"
          @refreshData="getDataAlumni" :loadBtnExport="loadBtnExport" @exportAlumnidata="exportAlumnidata"></AlumniTable>
        <!-- / Authors Table Card -->
      </a-col>
    </a-row>
    <!-- / Authors Table -->
  </div>
</template>

<script>
// "Authors" table component.
import AlumniTable from "./AlumniTable";
import _excelReport from "../excel-report/headerexcel.js";

// "Authors" table list of columns and their properties.
const tableColumns = [
  {
    title: "Student ID",
    dataIndex: "student_id",
    scopedSlots: { customRender: "student_id" },
    sorter: true,
    className: "center-colum column-header-alumni-data",
  },
  {
    title: "MUICAA Member",
    dataIndex: "membership_id",
    scopedSlots: { customRender: "membership_id" },
    sorter: true,
    className: "center-colum column-header-alumni-data",
  },
  {
    title: "Major",
    dataIndex: "major_detail.name_eng",
    scopedSlots: {
      customRender: "major",
    },
    className: "center-colum column-header-alumni-data-sub",
  },
  {
    title: "Graduate Year",
    dataIndex: "graduate_year",
    scopedSlots: { customRender: "graduate_year" },
    sorter: true,
    className: "center-colum column-header-alumni-data-sub",
  },
  {
    title: "Name",
    dataIndex: "full_name",
    scopedSlots: { customRender: "full_name" },
    sorter: true,
    className: "center-colum column-header-alumni-data-sub",
  },
  {
    title: "Name in Thai",
    dataIndex: "full_name_th",
    scopedSlots: { customRender: "full_name_th" },
    sorter: true,
    className: "center-colum column-header-alumni-data-sub",
  },
  // {
  //   title: "",
  //   scopedSlots: { customRender: "action" },
  //   className: "center-colum column-header-alumni-data",
  //   width: 150,
  // },
  // {
  //   title: "Member Status",
  //   dataIndex: "member_status",
  //   scopedSlots: { customRender: "member_status" },
  //   sorter: true,
  //   className: "center-colum column-header-alumni-data-sub",
  // },
  // {
  //   title: "MUICAA Member",
  //   dataIndex: "muicaa_member",
  //   scopedSlots: { customRender: "muicaa_member" },
  //   sorter: true,
  //   className: "center-colum column-header-alumni-data-sub",
  // },
  // {
  //   title: "MUICAA Steering Committee",
  //   dataIndex: "membership_id",
  //   scopedSlots: { customRender: "membership_id" },
  //   sorter: true,
  //   className: "center-colum column-header-alumni-data-sub",
  // },
  // {
  //   title: "GPA",
  //   dataIndex: "grade",
  //   scopedSlots: { customRender: "grade" },
  //   sorter: true,
  //   className: "center-colum column-header-alumni-data-sub",
  // },
  // {
  //   title: "Graduate Year",
  //   dataIndex: "graduate_date",
  //   scopedSlots: { customRender: "graduate_date" },
  //   sorter: true,
  //   className: "center-colum column-header-alumni-data-sub",
  // },
  // {
  //   title: "Graduate status",
  //   dataIndex: "graduate_status_remark",
  //   scopedSlots: { customRender: "graduate_status_remark" },
  //   sorter: true,
  //   className: "center-colum column-header-alumni-data-sub",
  // },
  {
    title: "Updated On",
    dataIndex: "updated_at",
    scopedSlots: { customRender: "updated_at" },
    sorter: false,
    className: "center-colum column-header-alumni-data-sub",
  },
  {
    title: "Action",
    key: "action",
    fixed: "right",
    width: 100,
    scopedSlots: { customRender: "action" },
    className: "center-colum column-header-alumni-data",
  },
];


export default {
  components: {
    AlumniTable,
  },
  data() {
    return {
      // Associating "Authors" table data with its corresponding property.
      tableData: [],
      // Associating "Authors" table columns with its corresponding property.
      tableColumns: tableColumns,
      loading: false,
      // pagination
      perPage: 10,
      countObjData: 0,
      currentPage: 1,
      offset: 0,
      // option selected
      optionNationality: [],
      optionProgram: [],
      optionJobselect: [],
      optionMajor: [],
      optionCountry: [],
      optionYear: [],
      //
      dataFilter: {},
      // export data : _excelReport
      loadBtnExport: false,
      headExcelAlumniData: _excelReport.reportA,
      dataExcel: [],
    };
  },
  mounted() {
    this.setOptionYear();
    this.getDataOption();
    this.getDataAlumni();
  },
  methods: {
    onChangePage(...args) {
      this.currentPage = args[0].currentPage;
      this.offset = args[0].offset;
      this.getDataAlumni();
    },
    onSearch(...args) {
      this.dataFilter = Object.assign({}, args[0].dataQuery);
      this.currentPage = 1;
      this.offset = 0;
      this.getDataAlumni();
    },
    async getDataAlumni() {
      this.tableData = [];
      this.loading = true;
      let url = "";
      if (Object.keys(this.dataFilter).length != 0) { 
        url = `/student_affair/alumni-profile/?limit=${this.perPage}&offset=${this.offset
          }&search=${this.dataFilter.searchText}&membership_id__isnull=${this.dataFilter.member?
            (this.dataFilter.member == "member" ? false : true)
            : ""
          }&graduate_year__gte=${this.dataFilter.yearStart}&graduate_year__lte=${this.dataFilter.yearEnd
          }&nationality=${this.dataFilter.nationality}&program_code=${this.dataFilter.program
          }&alumin_work__job_sector=${this.dataFilter.jobStatus}&major=${this.dataFilter.major
          }&alumin_education__country=${this.dataFilter.country}&subscribe=${this.dataFilter.statusSub
            ? this.dataFilter.statusSub == "Subscribe"
            : ""
          }`;
      } else {
        url = `/student_affair/alumni-profile/?limit=${this.perPage}&offset=${this.offset}`;
      }
      try {
        const res = await this.$http.get(url);
        if (res.status === 200) {
          this.tableData = res.data.results.map((item) => ({ ...item }));
          this.countObjData = res.data.count
          this.offset = 0;
          this.loading = false;
        } else {
          throw { res };
        }
      } catch (error) {
        this.tableData = [];
        this.$notification['error']({
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Failed to connect to the API`),
            ]);
          },
          description:
            `Error ${error.response.status} : /student_affair/alumni-profile/`,
        });
        this.loading = false;
      }
    },
    setOptionYear() {
      this.optionYear = [];
      for (let y = 0; y <= 200; y++) {
        let listY = parseInt(this.moment().format("YYYY") - y);
        this.optionYear.push(listY);
      }
    },
    async getDataOption() {
      const fetchNationality = await this.$http.get(
        `/student_affair/nationality/`
      );
      const fetchProgram = await this.$http.get(
        `/student_affair/program-code/`
      );
      const fetchJobSelect = await this.$http.get(
        `/student_affair/job-sector/`
      );
      const fetchMajor = await this.$http.get(`/student_affair/major/`);
      const fetchCount = await this.$http.get(
        `/student_affair/country-of-citizenship/`
      );
      Promise.all([
        fetchNationality,
        fetchProgram,
        fetchJobSelect,
        fetchMajor,
        fetchCount,
      ])
        .then((response) => {
          return Promise.all(response.map((r) => r.data));
        })
        .then(([listA, listB, listC, listD, listE]) => {
          this.optionNationality = listA.map((item) => {
            return {
              id: item.id,
              text: `${item.name_eng}`,
              value: item.id,
            };
          });
          this.optionProgram = listB.map((item) => {
            return {
              id: item.id,
              text: item.name_eng,
              value: item.id,
            };
          });
          this.optionJobselect = listC.map((item) => {
            return {
              id: item.id,
              text: item.name_eng,
              value: item.id,
            };
          });
          this.optionMajor = listD.map((item) => {
            return {
              id: item.id,
              text: item.name_eng,
              value: item.id,
            };
          });
          this.optionCountry = listE.map((item) => {
            return {
              id: item.id,
              text: `${item.name_eng}`, //`${item.name_thai}`
              value: item.id,
            };
          });
        })
        .catch((error) => {
          this.$notification['error']({
            message: function (h) {
              return h("div", [
                h("strong", { class: "" }, `Failed to connect to the API`),
              ]);
            },
            description:
              `Error ${error.response.status}`,
          });
        });
    },
    // export
    async exportAlumnidata() {
      this.loadBtnExport = true;
      this.dataExcel = [];
      try {
        const res = await this.$http.get(`/student_affair/alumni-profile/`);
        if (res.status === 200) {
          this.dataExcel = res.data.map((item) => ({
            A: item.id,
            B: `${_excelReport.printFormatData(
              item.muicaa_member,
              "string",
              ""
            )}`,
            C: `${_excelReport.printFormatData(
              item.muicaa_steering_committee,
              "string",
              ""
            )}`,
            D: `${_excelReport.printFormatData(item.student_id, "string", "")}`,
            E: `${_excelReport.printFormatData(
              item.name_detail.slice().reverse()[0],
              "Obj",
              "academic_title_detail"
            )}`,
            F: `${_excelReport.printFormatData(
              item.name_detail.slice().reverse()[0],
              "Obj",
              "title_name_detail"
            )}`,
            G: `${_excelReport.printFormatData(
              item.name_detail.slice().reverse()[0],
              "Obj",
              "eng_first_name"
            )}`,
            H: `${_excelReport.printFormatData(
              item.name_detail.slice().reverse()[0],
              "Obj",
              "eng_middle_name"
            )}`,
            I: `${_excelReport.printFormatData(
              item.name_detail.slice().reverse()[0],
              "Obj",
              "eng_last_name"
            )}`,
            J: `${_excelReport.printFormatData(
              item.name_detail.slice().reverse()[0],
              "Obj",
              "thai_first_name"
            )}`,
            K: `${_excelReport.printFormatData(
              item.name_detail.slice().reverse()[0],
              "Obj",
              "thai_middle_name"
            )}`,
            L: `${_excelReport.printFormatData(
              item.name_detail.slice().reverse()[0],
              "Obj",
              "thai_last_name"
            )}`,
            M: `${_excelReport.printFormatData(
              item.nationality_detetail,
              "Obj",
              "name_eng"
            )}`,
            N: `${_excelReport.printFormatData(
              item.program_code_detetail,
              "Obj",
              "name_eng"
            )}`,
            O: `${_excelReport.printFormatData(
              item.minor_detail,
              "Obj",
              "name_eng"
            )}`,
            P: `${_excelReport.printFormatData(
              item.concentration,
              "string",
              ""
            )}`,
            Q: `${_excelReport.printFormatData(item.grade, "string", "")}`,
            R: `${_excelReport.printFormatData(
              item.graduate_status_detail,
              "Obj",
              "name_eng"
            )}`,
            S: `${_excelReport.printFormatData(
              item.graduate_year,
              "string",
              ""
            )}`,
            T: `${_excelReport.printFormatData(
              item.graduate_date,
              "string",
              ""
            )}`,
            U: `${_excelReport.printFormatData(
              item.contact_detail.slice().reverse()[0],
              "Obj",
              "phone_number"
            )}`,
            V: ``,
            W: `${_excelReport.printFormatData(
              item.contact_detail.slice().reverse()[0],
              "Obj",
              "email"
            )}`,
            X: `${_excelReport.printFormatData(
              item.contact_detail.slice().reverse()[0],
              "Obj",
              "address"
            )}`,
          }));
          // //console.log(this.dataExcel);
          // create excle file
          const wb = this.XLSX.utils.book_new();
          const data = this.XLSX.utils.json_to_sheet(
            this.headExcelAlumniData.concat(this.dataExcel),
            {
              header: _excelReport.mainExcel,
              skipHeader: true,
            }
          );
          this.XLSX.utils.book_append_sheet(wb, data, "List-alumni-data");
          this.XLSX.writeFile(wb, "Alumni_Data.xlsx");
          this.loadBtnExport = false;
        } else {
          throw res;
        }
      }

      // if (this.tableData.length > 0) {
      //   this.dataExcel = this.tableData.map((item) => ({
      //     A: item.id,
      //     B: `${_excelReport.printFormatData(
      //       item.muicaa_member,
      //       "string",
      //       ""
      //     )}`,
      //     C: `${_excelReport.printFormatData(
      //       item.muicaa_steering_committee,
      //       "string",
      //       ""
      //     )}`,
      //     D: `${_excelReport.printFormatData(item.student_id, "string", "")}`,
      //     E: `${_excelReport.printFormatData(
      //       item.name_detail.slice().reverse()[0],
      //       "Obj",
      //       "academic_title_detail"
      //     )}`,
      //     F: `${_excelReport.printFormatData(
      //       item.name_detail.slice().reverse()[0],
      //       "Obj",
      //       "title_name_detail"
      //     )}`,
      //     G: `${_excelReport.printFormatData(
      //       item.name_detail.slice().reverse()[0],
      //       "Obj",
      //       "eng_first_name"
      //     )}`,
      //     H: `${_excelReport.printFormatData(
      //       item.name_detail.slice().reverse()[0],
      //       "Obj",
      //       "eng_middle_name"
      //     )}`,
      //     I: `${_excelReport.printFormatData(
      //       item.name_detail.slice().reverse()[0],
      //       "Obj",
      //       "eng_last_name"
      //     )}`,
      //     J: `${_excelReport.printFormatData(
      //       item.name_detail.slice().reverse()[0],
      //       "Obj",
      //       "thai_first_name"
      //     )}`,
      //     K: `${_excelReport.printFormatData(
      //       item.name_detail.slice().reverse()[0],
      //       "Obj",
      //       "thai_middle_name"
      //     )}`,
      //     L: `${_excelReport.printFormatData(
      //       item.name_detail.slice().reverse()[0],
      //       "Obj",
      //       "thai_last_name"
      //     )}`,
      //     M: `${_excelReport.printFormatData(
      //       item.nationality_detetail,
      //       "Obj",
      //       "name_eng"
      //     )}`,
      //     N: `${_excelReport.printFormatData(
      //       item.program_code_detetail,
      //       "Obj",
      //       "name_eng"
      //     )}`,
      //     O: `${_excelReport.printFormatData(
      //       item.minor_detail,
      //       "Obj",
      //       "name_eng"
      //     )}`,
      //     P: `${_excelReport.printFormatData(
      //       item.concentration,
      //       "string",
      //       ""
      //     )}`,
      //     Q: `${_excelReport.printFormatData(item.grade, "string", "")}`,
      //     R: `${_excelReport.printFormatData(
      //       item.graduate_status_detail,
      //       "Obj",
      //       "name_eng"
      //     )}`,
      //     S: `${_excelReport.printFormatData(
      //       item.graduate_year,
      //       "string",
      //       ""
      //     )}`,
      //     T: `${_excelReport.printFormatData(
      //       item.graduate_date,
      //       "string",
      //       ""
      //     )}`,
      //     U: `${_excelReport.printFormatData(
      //       item.contact_detail.slice().reverse()[0],
      //       "Obj",
      //       "phone_number"
      //     )}`,
      //     V: ``,
      //     W: `${_excelReport.printFormatData(
      //       item.contact_detail.slice().reverse()[0],
      //       "Obj",
      //       "email"
      //     )}`,
      //     X: `${_excelReport.printFormatData(
      //       item.contact_detail.slice().reverse()[0],
      //       "Obj",
      //       "address"
      //     )}`,
      //   }));
      //   // //console.log(this.dataExcel);
      //   // create excle file
      //   const wb = this.XLSX.utils.book_new();
      //   const data = this.XLSX.utils.json_to_sheet(
      //     this.headExcelAlumniData.concat(this.dataExcel),
      //     {
      //       header: _excelReport.mainExcel,
      //       skipHeader: true,
      //     }
      //   );
      //   this.XLSX.utils.book_append_sheet(wb, data, "List-alumni-data");
      //   this.XLSX.writeFile(wb, "Alumni_Data.xlsx");
      //   this.loadBtnExport = false;
      // } 
      catch (error) {
        this.loadBtnExport = false;
        this.$notification['error']({
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Can't export to excel file`),
            ]);
          },
          description:
            `Data table not fond.`,
        });
      }
    }
  },
};
</script>

<style>
.center-colum {
  text-align: center !important;
  font-weight: 700 !important;
}

th.column-header-alumni-data {
  background-color: #453c67 !important;
  color: #ffffff !important;
}

th.column-header-alumni-data-sub {
  background-color: #b7c4cf !important;
  color: #000000 !important;
}

/* th.column-header-alumni-data {
  background-color: #cccccc !important;
  color: #000 !important;
} */
</style>